import { NgxSpinnerModule } from 'ngx-spinner';
import { LoginRoutingModule } from './login-routing.module';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NbLayoutModule } from '@nebular/theme';
import { ThemeModule } from '../../../@theme/theme.module';
import { LoginLayoutComponent } from './login-layout.component';


@NgModule({
  imports: [
    FormsModule,
    ThemeModule,
    NbLayoutModule,
    NgxSpinnerModule,
    LoginRoutingModule
  ],
  declarations: [
    LoginLayoutComponent
  ],
})
export class LoginLayoutModule {
}
